import React, { useMemo } from 'react';
import SectionTitle from '../../yourProperties/Title';
import useTranslate from '../../../../customHooks/useTranslate';
import {
    useContractDetailData,
    useContractDetail,
} from '../../../contextsProperty/ContextContractDetail';
import DotIcon from '../../../components/DotIcon';
import Menu from '../../components/Menu';
import Card from '../../../../muiComponents/Card';
import Button from '../../../../muiComponents/Button';
import MuiGrid from '../../../../muiComponents/Grid';
import GridChild from '../../../../muiComponents/GridChild';
import Label from '../../yourProperties/Label';
import {
    doubleMD_ColumnGrid,
    full_ColumnGrid,
    gridSpacing20,
    gridSpacing30,
} from '../../../../utils/commonVariables/grid';
import {
    ContractDetailPanelNames,
    RATE_SCOPE_MODEL_KEY_ICON,
} from '../../../../types/contracts/contractTypes';
import MainInfoPanel from './panels/MainInfoPanels';
import Icon from '../../../../muiComponents/Icon';
import { RATE_SCOPE_MODEL_KEY_ICON_COLOR } from '../../../../utils/contractUtils/contractUtils';
import LoadingSection from './LoadingSection';
import useUserProfile from '../../../../customHooks/useUserProfile';

const MainInformation = () => {
    const translate = useTranslate();
    const { readOnlyUser } = useUserProfile();

    const {
        isMainInfoEmpty,
        isNewContract,
        openedPanel,
        isLoadingView,
        handleOpenPanel,
        handleOpenMainInfoPanel,
    } = useContractDetail();
    const {
        enabled,
        status,
        statusColor,
        currency,
        name,
        supplierHotel,
        ratePlan,
        rateScopeModel,
        rateScopeModelKey,
        description,
        agency,
    } = useContractDetailData();

    const handleCloseMainInfoPanel = () => {
        handleOpenPanel(null);
    };

    const menuItems = useMemo(() => {
        return [
            {
                text: readOnlyUser ? 'view' : isNewContract ? 'add' : 'edit',
                icon: readOnlyUser
                    ? 'Visibility'
                    : isNewContract
                    ? 'Add'
                    : 'Edit',
                onClick: () => {
                    handleOpenMainInfoPanel();
                },
            },
        ];
    }, [isNewContract, readOnlyUser]);

    return (
        <>
            {openedPanel === ContractDetailPanelNames.MAIN_INFO && (
                <MainInfoPanel
                    open={openedPanel === ContractDetailPanelNames.MAIN_INFO}
                    onClose={handleCloseMainInfoPanel}
                />
            )}
            {isLoadingView ? (
                <LoadingSection />
            ) : (
                <section className='contract-detail__section'>
                    <div className='flex-between flex-align-center'>
                        <SectionTitle text={translate('main_information')} />
                        <div className='flex-between flex-align-center gap-20'>
                            {isMainInfoEmpty ? null : (
                                <div className='flex flex-align-center gap-20'>
                                    <div className='flex flex-align-center gap-5'>
                                        <DotIcon
                                            truthy={enabled}
                                            falsy={!enabled}
                                        />
                                        <p>
                                            {enabled ? 'Enabled' : 'Disabled'}
                                        </p>
                                    </div>
                                    <div className='flex flex-align-center gap-5'>
                                        <DotIcon
                                            restStyles={{ color: statusColor }}
                                        />
                                        <p>{status}</p>
                                    </div>
                                </div>
                            )}

                            <Menu menuItems={menuItems} />
                        </div>
                    </div>
                    {isMainInfoEmpty ? (
                        <Card
                            className='contract-card__empty flex-center'
                            style={{ height: 150 }}
                        >
                            <Button
                                startIcon='Add'
                                onClick={() => handleOpenMainInfoPanel()}
                            >
                                {translate('add')}
                            </Button>
                        </Card>
                    ) : (
                        <Card>
                            <MuiGrid
                                style={{ width: 'auto', padding: '15px' }}
                                columnSpacing={gridSpacing30}
                                rowSpacing={gridSpacing20}
                            >
                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label text={translate('name')} />
                                    <p>{name}</p>
                                </GridChild>

                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label text={translate('hotel')} />
                                    <p>{supplierHotel}</p>
                                </GridChild>
                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label text={translate('agency')} />
                                    <p>{agency}</p>
                                </GridChild>
                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label text={translate('rate_plan')} />
                                    <p>{ratePlan}</p>
                                </GridChild>
                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label
                                        text={translate('rate_scope_model')}
                                    />
                                    <div className='flex gap-5'>
                                        <Icon
                                            iconName={
                                                RATE_SCOPE_MODEL_KEY_ICON[
                                                    rateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON
                                                ]
                                            }
                                            style={{
                                                color: RATE_SCOPE_MODEL_KEY_ICON_COLOR[
                                                    rateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON_COLOR
                                                ],
                                            }}
                                        />
                                        <p>{rateScopeModel}</p>
                                    </div>
                                </GridChild>
                                <GridChild gridProps={doubleMD_ColumnGrid}>
                                    <Label
                                        text={translate('currency')}
                                        className='text-capitalize'
                                    />
                                    <p>{currency}</p>
                                </GridChild>
                                <GridChild gridProps={full_ColumnGrid}>
                                    <Label text={translate('description2')} />
                                    <p className='multiline-overflow__2'>
                                        {description || '-----'}
                                    </p>
                                </GridChild>
                            </MuiGrid>
                        </Card>
                    )}
                </section>
            )}
        </>
    );
};

export default MainInformation;
